import { fromJS } from "immutable";

// utils
import avatarURL from "../utils/avatarURL";

const prependOptions = fromJS([
	{ id: "self", name: "Employee", url: avatarURL("E", 0) },
	{ id: "manager", name: "Employee's Manager", url: avatarURL("EM", 0) },
	{ id: "other", name: "Other Employee", url: avatarURL("OE", 0) },
]);

export const getOptionById = (id) => prependOptions.find((option) => option.get("id") === id);

export default prependOptions;
